// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridCarouselContainerStyle } from "@steiner/App/Components/Product/ProductGridCarouselContainer";
import { css } from "styled-components";

productGridCarouselContainerStyle.container = {
    css: css`
        position: relative;
        display: grid;
        grid-auto-columns: 1fr;
        grid-template-columns: 95px 1fr;
        grid-template-rows: 1fr;
        gap: 8px;
        height: 100%;
    `,
};

productGridCarouselContainerStyle.image = {
    css: css`
        grid-column: 1;
        grid-row: 1;
    `,
};

productGridCarouselContainerStyle.firstContainer = {
    css: css`
        grid-column: 2;
        grid-row: 1;
    `,
};

productGridCarouselContainerStyle.info = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

productGridCarouselContainerStyle.availability = {
    css: css`
        margin-top: 8px;
    `,
};

productGridCarouselContainerStyle.secondContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        grid-column: 1 / span 2;
        grid-row: 2;
    `,
};

productGridCarouselContainerStyle.addToCartActions = {
    css: css`
        display: flex;
        gap: 8px;
    `,
};
